export default {
  path: 'winter-service/v2/tasks/:id',
  name: 'WinterService2TaskDetails',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/TaskDetails.vue')
}
